export default __webpack_public_path__ + "static/media/5.47b0eea7.png";